import React from 'react'
import { OutboundLink } from 'react-ga'
import styles from './CardPrices.module.scss'
import { v4 } from 'uuid'
import { tcgplayerLink } from '../util'

const CardPrices = ({ prices }) => {
  const priceSources = ['cardkingdom', 'tcgplayer', 'coolstuffinc']
  const isCH = window.location.host === 'commandersherald.com'
  const cardkingdomUrl = prices?.cardkingdom
    ? `${prices?.cardkingdom.url}&partner_args=${isCH ? 'commandersherald' : 'edhrec,articles'}`
    : 'https://cardkingdom.com'
  const tcgplayerUrl = prices?.tcgplayer?.url
    ? tcgplayerLink({
        subId1: `${isCH ? 'commandersherald' : 'edhrec'},cardprice`,
        u: prices.tcgplayer.url.split('?')[0],
      })
    : '#'
  const priceLinks = {
    cardhoarder: () => (
      <OutboundLink
        alt='Buy at Cardhoarder'
        eventLabel={prices.cardhoarder.url}
        key={v4()}
        target='_blank'
        title='Buy at Cardhoarder'
        to={prices.cardhoarder.url}
      >
        <div className={styles.price}>
          <span>{`${prices.cardhoarder.price} TIX`}</span>
        </div>
      </OutboundLink>
    ),
    cardkingdom: () => (
      <OutboundLink
        alt='Buy at Card Kingdom'
        eventLabel={cardkingdomUrl}
        key={v4()}
        target='_blank'
        title='Buy at Card Kingdom'
        to={cardkingdomUrl}
      >
        <div className={styles.price}>
          <svg
            height='12'
            version='1.1'
            viewBox='0 0 3.7041667 3.1750001'
            width='14'
            xmlns='http://www.w3.org/2000/svg'
          >
            <g transform='translate(0 -293.82)'>
              <path d='m0 293.82v1.1592h0.52042v2.0158h2.6633v-2.0158h0.52042v-1.1592h-0.57636v1.0908h-0.49196v-1.084h-0.54839v1.084h-0.47074v-1.084h-0.54839v1.084h-0.49196v-1.0908z' />
            </g>
          </svg>
          <span>{`$${prices.cardkingdom.price.toFixed(2)}`}</span>
        </div>
      </OutboundLink>
    ),
    cardmarket: () => (
      <OutboundLink
        alt='Buy at Cardmarket'
        eventLabel={prices.cardmarket.url}
        key={v4()}
        rel='nofollow'
        target='_blank'
        title='Buy at Cardmarket'
        to={prices.cardmarket.url}
      >
        <div className={styles.price}>
          <span>
            {`${
              typeof prices.cardmarket.price === 'number' ? prices.cardmarket.price.toFixed(2) : prices.cardmarket.price
            } €`.replace('.', ',')}
          </span>
        </div>
      </OutboundLink>
    ),
    coolstuffinc: () => (
      <OutboundLink
        alt='Buy at CoolStuffInc'
        eventLabel={prices.coolstuffinc.url}
        key={v4()}
        target='_blank'
        title='Buy at CoolStuffInc'
        to={prices.coolstuffinc.url}
      >
        <div className={styles.price}>
          <svg width='24' height='12' version='1.1' viewBox='0 0 24 12' xmlns='http://www.w3.org/2000/svg'>
            <g transform='matrix(.056341 0 0 .056341 -.70313 -6.6902)'>
              <path d='m176.83 322.32c-17 6.11-36.63 9.17-58.89 9.17-21.88 0-40.74-4.18-56.6-12.54s-27.97-20.25-36.32-35.68c-8.36-15.43-12.54-33.22-12.54-53.37 0-21.68 4.68-40.98 14.04-57.89s22.59-29.97 39.69-39.19 36.77-13.83 59.03-13.83c17.77 0 34.96 2.15 51.58 6.45v57.17c-5.73-3.44-12.56-6.11-20.49-8.02s-15.95-2.87-24.07-2.87c-16.81 0-30.07 4.82-39.76 14.47-9.7 9.65-14.54 22.74-14.54 39.26 0 16.43 4.85 29.4 14.54 38.9 9.69 9.51 22.66 14.26 38.9 14.26 15 0 30.14-3.82 45.42-11.46v55.17z' />
              <path d='m351.49 265.72c0 13.66-3.65 25.55-10.96 35.68s-17.55 17.67-30.73 22.64-29.04 7.45-47.57 7.45c-21.49 0-41.17-3.63-59.03-10.89v-56.31c8.6 6.3 18.1 11.39 28.51 15.26s20.11 5.8 29.09 5.8c6.78 0 12.04-1.22 15.76-3.65 3.72-2.44 5.59-5.99 5.59-10.67 0-3.34-0.93-6.28-2.79-8.81s-4.68-4.89-8.45-7.09c-3.78-2.2-10.77-5.21-20.99-9.03-33.05-12.7-49.58-33.24-49.58-61.61 0-19.87 7.54-35.75 22.64-47.64 15.09-11.89 35.34-17.84 60.75-17.84 7.16 0 13.76 0.29 19.77 0.86s11.48 1.29 16.41 2.15c4.92 0.86 11.82 2.48 20.71 4.87v52.3c-17.29-9.46-34.29-14.19-51.01-14.19-6.88 0-12.42 1.29-16.62 3.87-4.21 2.58-6.3 6.11-6.3 10.6 0 4.3 1.7 7.86 5.09 10.67 3.39 2.82 10.48 6.47 21.28 10.96 21.3 8.6 36.37 18.01 45.21 28.23 8.8 10.22 13.22 22.35 13.22 36.39z' />
              <path d='m376.56 327.9v-205.47h61.9v205.47z' />
            </g>
          </svg>
          <span>{`$${prices.coolstuffinc.price}`}</span>
        </div>
      </OutboundLink>
    ),
    tcgplayer: () => (
      <OutboundLink
        alt='Buy at TCGplayer'
        eventLabel={tcgplayerUrl}
        key={v4()}
        target='_blank'
        title='Buy at TCGplayer'
        to={tcgplayerUrl}
      >
        <div className={styles.price}>
          <svg width='16' height='12' viewBox='0 0 16 12' version='1.1' id='svg708'>
            <defs id='defs712' />
            <path
              d='m 4.4262864,0.01228709 7.1480526,0.01922219 c 0.0064,-0.01273365 0.15313,0.02238514 0.275116,0.07494309 0.122714,0.0528822 0.220611,0.12328284 0.214203,0.1360977 0.02579,0 0.100493,0.1138744 0.168785,0.23172314 0.07316,0.12652712 0.138936,0.25767734 0.128635,0.25767734 L 12.399448,11.11334 c 0.01695,0 -0.03917,0.189548 -0.107467,0.341379 -0.04558,0.101628 -0.103817,0.186385 -0.122797,0.186385 0.0253,-0.0085 -0.02815,0.07414 -0.123769,0.154509 -0.08354,0.07015 -0.208445,0.138531 -0.221584,0.142911 l -7.3975386,0.03836 c -0.00697,0.021 -0.1695139,-0.02839 -0.3014752,-0.09538 C 4.0154788,11.826028 3.9311273,11.754411 3.936967,11.737054 3.9253688,11.742894 3.8226871,11.654568 3.7588558,11.555455 3.6823717,11.436795 3.644738,11.302644 3.6586885,11.295669 V 0.82790036 c -0.026765,0 0.016384,-0.13244793 0.093597,-0.26854573 0.058641,-0.10333048 0.1477773,-0.20876976 0.1779492,-0.2600294 0.039499,-0.0271709 0.096031,-0.087028 0.1827344,-0.14542513 0.124175,-0.08362147 0.283145,-0.1641608 0.3133173,-0.14161301 z M 7.381506,5.6347959 6.3356295,6.4407574 8.3889375,8.8970062 8.1106591,7.2082743 10.221472,5.7019526 9.3099903,4.7136621 11.132954,3.3416538 H 4.9348281 Z'
              id='path702'
            />
            <path
              d='M 3.0638487,1.0197187 0.59794852,1.422659 c -0.0100576,-0.00503 -0.15191368,0.069752 -0.25702858,0.1533736 -0.0922186,0.07324 -0.162052,0.1558879 -0.14729047,0.1632687 -0.0155723,0 -0.0908397,0.1008161 -0.1390177,0.2257211 -0.0498001,0.1292848 -0.06107399,0.2828206 -0.0515033,0.2828206 l 1.15139683,7.925222 c -0.013058,0 0.021007,0.14656 0.082404,0.26887 0.058965,0.117524 0.1449384,0.210878 0.157429,0.210878 -0.00876,0.0088 0.067968,0.09327 0.1676485,0.166513 0.1149287,0.08443 0.2567851,0.15743 0.2737365,0.140479 l 1.2281242,-0.09595 z'
              id='path704'
            />
            <path
              d='m 12.959162,1.0155011 2.427456,0.3454353 c 0.0093,-0.00462 0.122553,0.070239 0.218583,0.1493994 0.09944,0.08208 0.181276,0.1687839 0.165216,0.1768135 0.01249,0 0.08622,0.082404 0.142018,0.1927106 0.05824,0.1150099 0.09814,0.2582451 0.08508,0.2582451 l -1.157723,7.8101311 c 0.01784,0.01784 -0.156456,0.6014909 -0.163107,0.5948399 0.01727,0.0085 -0.05693,0.110062 -0.164323,0.202686 -0.102357,0.0884 -0.237239,0.168622 -0.25784,0.15232 l -1.295362,-0.06716 z'
              id='path706'
            />
          </svg>
          <span>{`$${prices.tcgplayer.price.toFixed(2)}`}</span>
        </div>
      </OutboundLink>
    ),
  }
  return (
    <div className={styles.prices}>
      {prices && (
        <>
          {[0, 1, 2].map((i) => {
            return prices[priceSources[i]] && priceLinks[priceSources[i]] ? (
              priceLinks[priceSources[i]]()
            ) : (
              <span key={v4()}>&nbsp;</span>
            )
          })}
        </>
      )}
    </div>
  )
}

CardPrices.propTypes = {}

export default CardPrices
